<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">{{ $t('sale_exchange_list') }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <router-link to="/sale/exchange" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-plus-circle"></i> {{$t('new')}}</router-link>
            <div class="pull-right">
                <div class="form-inline">
                    <input type="text" class="form-control form-control-sm max-width" :placeholder="$t('sale_exchange_no')" v-model="query.Text" @keypress.enter="toList"/>
                </div>
            </div>
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="exportExcel">
                <i class="fa fa-file-excel-o" aria-hidden="true"></i>
                {{$t('export_excel')}}
            </button>
        </div>
        <div class="x_body">
            <div class="card x_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="form-group">
                                <input type="date" class="form-control form-control-sm" v-model="query.FromDate"/>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <input type="date" class="form-control form-control-sm" v-model="query.ToDate"/>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="form-group">
                                <CustomerDropdown :is-all="true" :place="$t('all')" @select="customerChange"></CustomerDropdown>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <button type="button" class="btn btn-default btn-sm" @click="toList"><i class="fa fa-search" aria-hidden="true"></i> {{$t('search')}}</button>
                            </div>
                        </div>
                    </div>
                    <table class="table table-bordered table-striped table-sm no-bor table-scroll">
                        <thead>
                            <tr>
                                <th class="text-center">#</th>
                                <th class="sorting">
                                    <span class="sort-field width-column" @click="onSort('Num')">{{ $t('code') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                </th>
                                <th class="sorting">
                                    <span class="sort-field width-column" @click="onSort('Date')">{{ $t('date') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                </th>
                                <th class="sorting">
                                    <span class="sort-field width-column" @click="onSort('CustomerName')">{{ $t('customer') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                </th>
                                <th class="sorting">
                                    <span class="sort-field width-column" @click="onSort('EmployeeName')">{{ $t('sale_reputation') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                </th>
                                <th class="sorting">
                                    <span class="sort-field width-column" @click="onSort('BranchName')">{{ $t('delivery_to_branch') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                </th>
                                <th class="sorting">
                                    <span class="sort-field" @click="onSort('RefNum')">{{ $t('ref_num') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                </th>
                                <th class="sorting">
                                    <span class="sort-field width-column" @click="onSort('TotalAmount')">{{ $t('total_amount') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                </th>
                                <th class="sorting">
                                    <span class="sort-field width-column" @click="onSort('Discount')">{{ $t('discount') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                </th>
                                <th class="sorting">
                                    <span class="sort-field width-column" @click="onSort('PaidAmount')">{{ $t('receive_amount') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                </th>
                                <th class="sorting">
                                    <span class="sort-field width-column" @click="onSort('Status')">{{ $t('status') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(ret, index) in records" :key="index">
                                <td class="text-center">{{index+1}}</td>
                                <td><router-link :to="{name: 'sale_exchange_preview', params: {id: ret.Id}}">{{ret.Num}}</router-link></td>
                                <td>{{$format(ret.Date, 'DD/MM/YYYY')}}</td>
                                <td>{{ret.CustomerName}}</td>
                                <td>{{ret.EmployeeName}}</td>
                                <td>{{ret.BranchName}}</td>
                                <td>{{ret.RefNum}}</td>
                                <td class="text-right">{{$money(ret.TotalAmount)}}</td>
                                <td class="text-right">{{$money(ret.Discount)}}</td>
                                <td class="text-right">{{$money(ret.PaidAmount)}}</td>
                                <td class="cell-badge" v-html="$statusLabel(ret.Status)"></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="card-footer">
                    <span>{{$t('total_record')}}: {{query.Total}}</span>
                    <div class="pull-right">
                        <b-pagination size="sm" pills :total-rows="query.Total" :per-page="query.Limit" v-model="query.Page" :prev-text="$t('pre')" :next-text="$t('next')"
                        hide-goto-end-buttons
                        @change="paging($event)"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { CustomerDropdown } from '../Customer';
export default {
    components: { CustomerDropdown },
    data(){
        return {
            query: {
                Text: '',
                FromDate: '',
                ToDate: '',
                Limit: 25,
                Page: 1,
                Total: 0,
                SortType: '',
                SortField: ''
            },
            records: []
        }
    },
    created(){
        this.toList();
    },
    methods: {
        toList(){
            let loading = this.$loading.show();
            this.$api().post('sale/exchanges', this.query).then(res => {
                if(this.$isValid(res)){
                    this.records = res.data.Json.Exchanges;
                    this.query.Total = res.data.Total;
                }
            }).finally(() => { loading.hide(); });
        },
        onSort(field){
            this.query.SortField = field;
            if(this.query.SortType == 'ASC') this.query.SortType = 'DESC';
            else this.query.SortType = 'ASC';
            this.toList();
        },
        paging(e){
            this.query.Page = e;
            this.toList();
        },
        customerChange(e){
            if(e == null) this.query.CustomerId = '';
            else this.query.CustomerId = e.Id;
            this.toList();
        },
        exportExcel(){
            let loading = this.$loading.show();
            this.$api()({
                url: this.$base() + 'sale/exchanges/export/excel',
                method: 'post',
                data: this.query,
                responseType: 'blob'
            }).then(res => {
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'sale-exchanges.xlsx');
                document.body.appendChild(link);
                link.click();
            }).finally(function(){ loading.hide();});
        },
    }
}
</script>
